import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface ReporteEficienciaRADParams {
    min: Date;
    max: Date;
}

type Entity = ReporteEficienciaRADParams;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGenerar: () => Promise<void>;
}

/**
* Componente para editar un Entity
*/
export class ReporteEficienciaRADPForm extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            min: validation.required,
            max: validation.required
        };
    }


    render() {
        const { value, onGenerar } = this.props;
        const getField = this.getField;
        const DateTime = getField(kea.DateTime);
        return (
            <div>
                <kea.Title titulo="Reporte de eficiencia de RAD" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <DateTime field="min" label="Fecha inicio:"/>,
                    <DateTime field="max" label="Fecha final:"  />,
                ])}
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={onGenerar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/reporte/form.tsx